// extracted by mini-css-extract-plugin
export default {"attachments-info-container":"AttachmentInfo_attachments-info-container__w2lAa","attachments-info-icon":"AttachmentInfo_attachments-info-icon__ILXpq"};